import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Link } from "react-router-dom";
import {
  Box,
  Container,
  Grid,
  GridItem,
  Heading,
  Button,
  useMediaQuery
} from "@chakra-ui/react";
import CatNavbar from "./CatNavbar";
import ProductCard from "./ProductCards/ProductCard";
import FilterBar from "./SearchComponents/FilterBar";
import AgriWeatherForecast from "./components/Weather/AgriWeatherForecast";
import "./MobileHeader.css";

export default function CatagoryView() {
  const { category } = useParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [visibleproducts, setVisibleProducts] = useState(10);
  const hasMoreProductsToLoad = visibleproducts < products.length;
  const [isMobile] = useMediaQuery("(max-width: 768px)");
  
  // Filter state
  const [filters, setFilters] = useState({
    priceRange: [0, 100000],
    quality: [],
    sortBy: "newest"
  });

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get("https://api.agromanch.com/getProducts");
        // Filter products by category
        const filteredProducts = response.data.filter(
          (product) => product.catagory === category
        );
        setProducts(filteredProducts);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching products:", error);
        setLoading(false);
      }
    };

    fetchProducts();
  }, [category]);

  // Apply filters
  const filteredProducts = products.filter(product => {
    // Price range filter
    const price = parseFloat(product.price);
    if (price < filters.priceRange[0] || price > filters.priceRange[1]) {
      return false;
    }
    
    // Quality filter
    if (filters.quality.length > 0 && !filters.quality.includes(product.quality)) {
      return false;
    }
    
    return true;
  });

  // Sort products
  const sortedProducts = [...filteredProducts].sort((a, b) => {
    if (filters.sortBy === "newest") {
      return new Date(b.createdAt) - new Date(a.createdAt);
    } else if (filters.sortBy === "price_low_high") {
      return parseFloat(a.price) - parseFloat(b.price);
    } else if (filters.sortBy === "price_high_low") {
      return parseFloat(b.price) - parseFloat(a.price);
    }
    return 0;
  });

  return (
    <>
      <Container maxW="container.xl" mt={4}>
        <Heading as="h2" size="xl" mb={4}>{category}</Heading>
        
       
        
        <FilterBar filters={filters} setFilters={setFilters} />

        <Grid
          templateColumns={{
            base: "1fr",
            md: "repeat(2, 1fr)",
            lg: "repeat(3, 1fr)",
          }}
          gap={6}
          mt={4}
        >
          {sortedProducts.slice(0, visibleproducts).map((product) => (
            <GridItem key={product._id}>
              <Link to={`/preview_ad/${product._id}`}>
                <ProductCard product={product} />
              </Link>
            </GridItem>
          ))}
        </Grid>
        {hasMoreProductsToLoad && (
          <Box textAlign="center" mt={8}>
            <Button
              className="mb-2"
              bgGradient="linear(to-r, teal.400, cyan.600)"
              color="white"
              _hover={{
                bgGradient: "linear(to-r, teal.600, cyan.800)",
              }}
              _active={{
                bgGradient: "linear(to-r, teal.800, cyan.900)",
              }}
              onClick={() => {
                setVisibleProducts((prev) => prev + 10);
              }}
            >
              Load More
            </Button>
          </Box>
        )}
      </Container>
    </>
  );
}
